import cn from "classnames";
import styles from "./Tabs.module.scss";

import { useTabsContext } from "./Tabs.context";

interface ITabControlProps {
  className?: string;
  dataFor: string;
}

export const TabControl: RFC<ITabControlProps> = ({ className, children, dataFor, ...props }) => {
  const { activeTabId, setActiveTabId } = useTabsContext();

  return (
    <button
      type="button"
      className={cn(styles.control, activeTabId === dataFor && styles.active, className)}
      onClick={() => setActiveTabId(dataFor)}
      {...props}
    >
      {children}
    </button>
  );
};

TabControl.displayName = "TabControl";
